// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const StripeLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="28" viewBox="0 0 20 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.96851 8.33065C7.96851 7.13065 8.97639 6.66911 10.6457 6.66911C13.0394 6.66911 16.0629 7.3768 18.4568 8.63834V1.40757C15.8425 0.392188 13.2598 -0.0078125 10.6457 -0.0078125C4.25197 -0.0078125 0 3.25372 0 8.69988C0 17.1921 11.9685 15.8383 11.9685 19.4999C11.9685 20.9152 10.7087 21.3769 8.94488 21.3769C6.33071 21.3769 2.99212 20.3306 0.346457 18.9152V26.2383C3.27558 27.4691 6.23622 27.9922 8.94488 27.9922C15.496 27.9922 20 24.8229 20 19.3153C19.9685 10.146 7.96851 11.7768 7.96851 8.33065Z"
      fill="#635BFF"
    />
  </svg>
);
